export interface IEsriMapConstraints {
  minScale?: number;
  maxScale?: number;
  minZoom?: number;
  maxZoom?: number;
  snapToZoom?: boolean;
  rotationEnabled?: boolean;
}
